import { render, staticRenderFns } from "./GlobalCarousel.vue?vue&type=template&id=4c3a28a6&scoped=true"
import script from "./GlobalCarousel.vue?vue&type=script&lang=js"
export * from "./GlobalCarousel.vue?vue&type=script&lang=js"
import style0 from "./GlobalCarousel.vue?vue&type=style&index=0&id=4c3a28a6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3a28a6",
  null
  
)

export default component.exports